<template>
  <div class="institute">
    <Header current="institute" active="institute" @scroll="handleScroll"></Header>
    <div class="dbi">
      <img :src="banner" />
      <div class="con">
        <div class="dbi-icon"></div>
        <p class="b-txt hide">{{ $t('lang.dbi.banner') }}</p>
        <p class="total">{{ $t('lang.dbi.total') }}</p>
        <h5 class="noafter">{{ $t('lang.dbi.learn') }}</h5>
      </div>
    </div>
    <div class="open con" id="open">
      <h3>{{ $t('lang.dbi.open') }}</h3>
      <div class="unresolved">
        <img :src="ots" />
        <!-- <h5 class="tit">{{ $t('lang.dbi.unresolved') }}</h5>
        <div class="list">
          <div class="item" v-for="(item, index) in $t('lang.dbi.list')" :key="index">
            <span class="num">{{ index + 1 }}</span>
            <p>{{ item }}</p>
          </div>
        </div>-->
      </div>
      <p class="f12" v-for="(item, index) in $t('lang.dbi.text')" :key="index">{{ item }}</p>
      <!-- <div class="link">
        <a href="javascript:void(0)">{{ $t('lang.dbi.go') }}</a>
      </div>-->
      <a href="javascript:void(0)" @click="gotoLink(dbi.sign)">{{ $t('lang.dbi.sign') }}</a>
    </div>
    <div class="fund" id="fund">
      <div class="con">
        <div v-for="(item, index) in $t('lang.dbi.fund')" :key="index">
          <h3 v-if="index == 0">{{ item.tit }}</h3>
          <h5 v-else>{{ item.tit }}</h5>
          <p class="f12">{{ item.text }}</p>
        </div>
      </div>
    </div>
    <div class="proposal con">
      <h3>{{ $t('lang.dbi.proposal') }}</h3>
      <p class="f12">{{ $t('lang.dbi.ptxt') }}</p>
      <h5>{{ $t('lang.dbi.the') }}</h5>
      <div class="steps">
        <p class="call f12">{{ $t('lang.dbi.call') }}</p>
        <p class="initial f12">{{ $t('lang.dbi.initial') }}</p>
        <p class="official f12">{{ $t('lang.dbi.official') }}</p>
      </div>
      <button class="btn" @click="gotoLink(dbi.get_start)">{{ $t('lang.dbi.start') }}</button>
    </div>
    <div class="bar"></div>
    <div class="about con">
      <h3>{{ $t('lang.dbi.about') }}</h3>
      <p class="f12">{{ $t('lang.dbi.atxt') }}</p>
      <div :class="{'our':true,'cn':lang=='zh-CN'}"></div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { dbi } from "../../common/link.js";
export default {
  name: "Institute",
  components: {
    Header,
  },
  data() {
    return {
      banner: "",
      ots: "",
      dbi,
      imgInv: 0,
      lang: "",
    };
  },
  created() {
    this.banner = require("../../assets/images/dbiBanner.png");
    this.ots = require("../../assets/images/ots-en-US.png");
    localStorage.setItem("url", "institute");
    clearInterval(this.imgInv);
    this.lang = this.$i18n.locale;
    this.imgInv = setInterval(() => {
      this.lang = this.$i18n.locale;
      if (this.lang == "zh-CN") {
        this.ots = require("../../assets/images/ots-zh-CN.png");
      } else {
        this.ots = require("../../assets/images/ots-en-US.png");
      }
    }, 500);
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.id == "open" || this.$route.params.id == "fund") {
      this.handleScroll(this.$route.params.id);
    }
  },
  methods: {
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(url, "_blank");
    },
    handleScroll(id) {
      if (id) {
        let offsetTop = document.querySelector("#" + id).offsetTop;
        window.scrollTo(0, offsetTop - 60);
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

image(url) {
  background: url('../../assets/images/' + url + '.png') center center no-repeat;
  background-size: 100% auto;
}

step(w, h, url) {
  content: '';
  display: block;
  width: w;
  height: h;
  margin: 0.2rem auto;
  background: url('../../assets/images/' + url + '.png') center center no-repeat;
  background-size: 100% auto;
}

.institute {
  padding-top: 0.96rem;

  h3 {
    title();
    margin-bottom: 0.3rem;
  }

  p {
    text();
    color: #000;
    margin-bottom: 0.3rem;
  }

  h5 {
    subtitle();
    margin-bottom: 0.3rem;

    &:after {
      content: '';
      display: block;
      width: 0.34rem;
      height: 1px;
      background-color: $dark;
    }

    &.noafter {
      &:after {
        display: none;
      }
    }
  }

  .dbi {
    position: relative;
    text-align: center;

    img {
      width: 17.5rem;
      min-width: 100%;
      height: 5.9rem;
    }

    .con {
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -6rem;
      padding: 0.95rem;

      .total {
        font-size: 0.3rem;
        margin: 0.5rem auto 0;
      }

      h5 {
        font-weight: 600;
      }
    }

    .dbi-icon {
      width: 4.06rem;
      height: 1.06rem;
      image('dbi');
      margin: 0 auto 0.45rem;
    }

    .b-txt {
      padding: 0 3%;
      text-indent: 0.2rem;
      text-align: center;
    }
  }

  .open {
    .unresolved {
      margin-bottom: 0.45rem;

      img {
        width: 100%;
        margin: auto -0.1rem;
      }

      .tit {
        text-align: center;

        &:after {
          display: none;
        }
      }
    }

    .list {
      center();
      flex-wrap: wrap;
      padding: 0 0.3rem;
    }

    .item {
      width: 40%;
      height: 0.7rem;
      margin: 0 5% 0.3rem;
      center();
      background-color: rgba(247, 147, 26, 0.08);

      p {
        flex: 1;
        height: 0.7rem;
        line-height: 0.7rem;
        padding-left: 0.3rem;
        margin-bottom: 0;
        ellipsis();
      }
    }

    .num {
      width: 0.65rem;
      height: 0.7rem;
      line-height: 0.7rem;
      font-size: 0.48rem;
      text-align: center;
      color: $white;
      background-color: rgba(247, 147, 26, 0.4);
    }

    .link {
      margin-bottom: 0.3rem;
    }
  }

  .fund {
    background-color: #dedede;
  }

  .proposal {
    h5 {
      text-align: center;

      &:after {
        display: none;
      }
    }

    .steps {
      center();

      p {
        position: relative;
        flex: 1;
        text-align: center;

        &:after {
          position: absolute;
          top: 50%;
          right: 0;
          margin-top: -0.13rem;
          step(0.27rem, 0.26rem, 'step-arrow');
          margin: 0;
        }

        &:last-child:after {
          display: none;
        }
      }

      .call:before {
        step(1.31rem, 1.11rem, 'step1');
      }

      .initial:before {
        step(1.27rem, 1.2rem, 'step2');
      }

      .official:before {
        step(1.16rem, 1.15rem, 'step3');
      }
    }

    .btn {
      display: block;
      width: 3.71rem;
      margin: 0.2rem auto 0;
    }
  }

  .bar {
    width: 100%;
    height: 0.15rem;
    background-color: $btnColor;
  }

  .about {
    .our {
      // box-shadow: 0 3px 8px rgba(10, 10, 10, 0.1)
      width: 12rem;
      height: 5.45rem;
      margin: -7px;
      margin-top: 7;
      background: url('../../assets/images/our-en-US.png') center center no-repeat;
      background-size: 100% 100%;
    }

    .our.cn {
      background: url('../../assets/images/our-zh-CN.png') center center no-repeat;
      background-size: 100% 100%;
    }
  }
}

@media screen and (max-width: 720px) {
  .institute {
    h5 {
      font-size: 0.4rem;
    }

    padding-top: 40px;

    .proposal {
      .btn {
        width: 160px;
      }
    }

    .open {
      .unresolved {
        padding: 10px;
      }

      .list {
        display: block;
        padding: 10px;
      }

      .item {
        width: 90%;
        margin: 0 auto 10px;
      }

      a {
        font-size: 0.35rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/institute/Institute.vue